import React from 'react'
import styled from 'styled-components'
import media from '../../../styles/media'

const TitleWrapper = styled.p`
  font-size: 20px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  padding-top: 60px;
  ${media.md`
    font-size: 32px;
    padding-top: 0;
  `};
`

function Title({ title }) {
  return (
    <div>
      <TitleWrapper>{title}</TitleWrapper>
    </div>
  )
}

export default Title



// WEBPACK FOOTER //
// ./src/components/step/title/title.js